import React, { useEffect, useState, useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  fetchCancellationPolicy,
  updateCancellationPolicyThunk,
} from "../../slices/staticPages/thunk";
import { resetCancellationPolicyFlag } from "../../slices/staticPages/reducer";
import { CKEditor } from "@ckeditor/ckeditor5-react";
import ClassicEditor from "@ckeditor/ckeditor5-build-classic";
import { Container } from "reactstrap";
import BreadCrumb from "../../Components/Common/BreadCrumb";

function CancellationPolicy() {
  const dispatch = useDispatch();
  const state = useSelector((state) => state);

  const cancellationPolicy = state?.StaticPages?.cancellationPolicy || {};
  const editorRef = useRef(null);

  // === IMPORTANT ===
  // Use `null` first → so CKEditor does not mount early
  const [editorData, setEditorData] = useState(null);

  // Fetch API on mount
  useEffect(() => {
    dispatch(fetchCancellationPolicy());
  }, [dispatch]);

  // Set API data to editor
  useEffect(() => {
    if (cancellationPolicy?.data?.htmlContent !== undefined) {
      setEditorData(cancellationPolicy.data.htmlContent || "");
    }
  }, [cancellationPolicy?.data?.htmlContent]);

  // Save
  const handleSave = () => {
    dispatch(updateCancellationPolicyThunk({ htmlContent: editorData }));
  };

  // Reset success flag
  useEffect(() => {
    if (cancellationPolicy?.success) {
      const timer = setTimeout(
        () => dispatch(resetCancellationPolicyFlag()),
        3000
      );

      return () => clearTimeout(timer);
    }
  }, [cancellationPolicy?.success, dispatch]);

  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid>
          <BreadCrumb title="Cancellation Policy" pageTitle="Cancellation Policy" />
        </Container>
      </div>
      <div className="static-page" style={{ marginBottom: '55px', background: "white", padding: "1rem" }} >
        <label className="form-label fw-bold">HTML Content</label>
        {/* CKEditor */}
        <div className="border p-2">
          <CKEditor
            editor={ClassicEditor}
            data={editorData}
            onChange={(event, editor) => {
              try {
                setEditorData(editor.getData());
              } catch (error) {
                console.error("CKEditor error:", error);
              }
            }}
          />
        </div>

        <button
          className="btn btn-primary mt-3"
          disabled={cancellationPolicy?.loading}
          onClick={handleSave}
        >
          {cancellationPolicy?.loading ? "Saving..." : "Save"}
        </button>

        {/* Preview */}
        <h5 className="form-label fw-bold mt-4">Preview</h5>
        <div
          style={{
            border: "1px solid #ccc",
            padding: "15px",
            borderRadius: "4px",
            minHeight: "100px",
          }}
          dangerouslySetInnerHTML={{ __html: editorData }}
        />
      </div>
    </React.Fragment>
  );
}

export default CancellationPolicy;
